import MentoringOldManIcon from './MentoringOldManIcon.vue';

export default MentoringOldManIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/components/avatar/components/stub/components/oldman/index.ts